// extracted by mini-css-extract-plugin
export var active = "_aw-7";
export var blink = "_aw-8";
export var dropDownSelector = "_aw-4";
export var dropDownWrapper = "_aw-3";
export var fakeCursor = "_aw-6";
export var fontSizeButton = "_aw-9";
export var formQuillEditor = "_aw-0";
export var pressed = "_aw-a";
export var qlBlank = "_aw-1";
export var textFormattingToolbar = "_aw-2";
export var textToolbarOption = "_aw-5";